module.exports = __webpack_public_path__ + "img/modal-delete-auto.aa9b1b91.svg";